import { render, staticRenderFns } from "./Backgrounds.vue?vue&type=template&id=b208f850&"
import script from "./Backgrounds.vue?vue&type=script&lang=ts&"
export * from "./Backgrounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports